import { Text, View } from "@react-pdf/renderer";
import { creditCardSurchargeStatement } from "helpers/fee";

import { styles } from "../styles";

/**
 * CLE-2798 — printed under the estimate table when the estimate's payer carries the credit-card
 * surcharge (Ani, 2026-09-16: "the payer it has it for"). The rate is the one snapshotted on the order,
 * so an estimate created before the payer got the surcharge, or for a payer without it, prints nothing.
 */
export function SurchargeStatement({ percent }: { percent?: number | null }) {
  const rate = Number(percent ?? 0);
  if (!(rate > 0)) return null;
  return (
    <View style={{ ...styles.section, marginTop: 4, marginBottom: 0 }}>
      <Text style={{ ...styles.bodyText, lineHeight: 1.2 }}>
        {creditCardSurchargeStatement(rate)}
      </Text>
    </View>
  );
}
